<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}
</style>
<template>
	<div>
		<titles titlename="我的成绩管理" titlecontent="这里可以看到我的成绩管理" :mbx="paths"></titles>
		<div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入用户名" v-model="pagesobj.ui_userName" clearable></el-input></div>
			</div>
			<div class="sclectlable">
				<div><el-input placeholder="请输入真实姓名" v-model="pagesobj.ui_realName" clearable></el-input></div>
			</div>

			<div class="sclectlable">
				<div><el-input placeholder="请输入试卷名称" v-model="pagesobj.SPA_PaperTitle" clearable></el-input></div>
			</div>

			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.SPA_TYPE" placeholder="请选择试卷类型">
						<el-option value="1" label="正式考试">正式考试</el-option>
						<el-option value="0" label="模拟考试">模拟考试</el-option>
					</el-select>
				</div>
			</div>

			<div class="primarybtn"><el-button type="primary" icon="el-icon-search" @click="getlist()">搜索</el-button></div>
		</div>

		<div class="tables" ref="homes">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesobj.pageSize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" :resizable="false" width="55"></el-table-column>
							<el-table-column label="用户名" :resizable="false" prop="ui_realName" width="120">
								<template slot-scope="scope">
									<p v-if="!scope.row.ui_guid" style="color: red;">暂无用户信息</p>
									<p v-if="scope.row.ui_guid">{{ scope.row.ui_realName }}</p>
								</template>
							</el-table-column>
							<el-table-column label="试卷名称" :resizable="false" prop="SPA_PaperTitle">
								<template slot-scope="scope">
									<p style="text-align: left;" :title="scope.row.SPA_PaperTitle">{{ scope.row.SPA_PaperTitle }}</p>
								</template>
							</el-table-column>
							<el-table-column label="考试开始时间" :resizable="false" prop="SSP_StartTime" width="200"></el-table-column>
							<el-table-column label="交卷时间" :resizable="false" prop="SSP_EndTime" width="200"></el-table-column>
							<el-table-column label="总分" :resizable="false" prop="SSP_Scores" width="60"></el-table-column>
							<el-table-column label="单选题分数" :resizable="false" prop="SSP_SingleScore" width="100"></el-table-column>
							<el-table-column label="多选题分数" :resizable="false" prop="SSP_MultiScore" width="100"></el-table-column>
							<el-table-column label="判断题分数" :resizable="false" prop="SSP_JudgeScores" width="100"></el-table-column>
							<el-table-column label="状态" :resizable="false" prop="SPA_TYPE" width="140">
								<template slot-scope="scope">
									<div style="color: #fff;width: 40%;margin: 0 auto;" :style="{ 'background-color': scope.row.SSP_Status == 1 ? '#4eeb73' : '#ff0000' }">
										{{ scope.row.SSP_Status == 1 ? '已考试' : '未考试' }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="试卷类型" prop="SPA_TYPE" width="100">
								<template slot-scope="scope">
									{{ scope.row.SPA_TYPE == 1 ? '正式考试' : '模拟考试' }}
								</template>
							</el-table-column>
							<el-table-column label="操作" :resizable="false" fixed="right" width="100">
								<template slot-scope="scope">
									<p v-if="!scope.row.ui_guid" style="color: red;">暂无用户信息</p>
									<el-button v-if="scope.row.ui_guid" size="mini" style="background-color: #409eff;" @click="goexminxq(scope.row)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tableData.length }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { UserPerlist } from '@/request/api/homesview/yunhomes/yunhom.js';

import $ from 'jquery';
import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/examinationmanage/examinationmanage',
					name: '成绩管理'
				}
			],
			tabsnum: 10,
			totalall: 0,
			tabindex: 1,
			// 专业筛选项列表
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				},
				{
					value: '选项3',
					label: '蚵仔煎'
				},
				{
					value: '选项4',
					label: '龙须面'
				},
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				SSP_Status: '',
				SPA_PaperTitle: '',
				ui_realName: '',
				ui_userName: '',
				SPA_TYPE: ''
			},
			tabsnun: 1,
			username: '',
			realnamne: '',
			eaxmin: '',
			tableData: []
		};
	},
	components: {
		titles
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.getlist();
		if (AppOptions.appEmpty) {
			let homestop = $(this.$refs.homes).offset().top;
			let homesleft = $(this.$refs.homes).offset().left;

			if (localStorage.getItem('token') && homesleft < 200) {
				// console.log("刷新页面")
				// if (localStorage.getItem('token')) {
				// 	window.location.reload();
				// }
			}
		}
	},
	methods: {
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getlist();
		},
		changetablesize() {
			this.getlist();
		},
		goexminxq(ite) {
			this.$router.push('/textorexamin/examinationmanage/examinxq?SPA_GUID=' + ite.SPA_GUID + '&UI_GUID=' + ite.ui_guid + '&SSP_Scores=' + ite.SSP_Scores);
		},
		getlist() {
			UserPerlist(this.pagesobj).then(res => {
				this.tableData = res.data.data.list;
				this.totalall = res.data.data.totalCount;
			});
		}
	}
};
</script>
